import {
  Briefcase,
  Home,
  FileText,
  Users,
  TrendingUp,
  Package,
  CreditCard,
  Globe,
  Percent,
  Database,
} from "react-feather";
import { CAPABILITIES } from "../../auth/permissions";

const pagesSection = [
  {
    href: "/dashboard",
    icon: Home,
    title: "Dashboard",
    capability: CAPABILITIES.dashboard,
  },
  {
    href: "/customers/list",
    icon: Users,
    title: "Customers",
    capability: CAPABILITIES.customersRead,
  },
  {
    href: "/sales",
    icon: TrendingUp,
    title: "Sales",
    children: [
      {
        href: "/sales/prospectmanagement",
        title: "Prospects",
        capability: CAPABILITIES.prospectsRead,
      },
      {
        href: "/sales/feemonitor",
        title: "Customer Fee Monitor",
        capability: CAPABILITIES.feeMonitorRead,
      },
    ],
  },
  {
    href: "/Invoices",
    icon: FileText,
    title: "Invoices",
    capability: CAPABILITIES.invoicesWrite,
    children: [
      {
        href: "/invoices/AllInvoices",
        title: "All",
        capability: CAPABILITIES.invoicesWrite,
      },
      {
        href: "/invoices/CustomerUploadedFiles",
        title: "Customer Uploaded Invoices",
        capability: CAPABILITIES.invoicesWrite,
      },
      {
        href: "/invoices/ManualInvoices",
        title: "Manual Invoices",
        capability: CAPABILITIES.invoicesWrite,
      },
      {
        href: "/invoices/AddAutomatedInvoices",
        title: "Add OCR Invoices",
        capability: CAPABILITIES.invoicesWrite,
      },
      {
        href: "/invoices/CheckAutomatedInvoices",
        title: "Review OCR Invoices",
        capability: CAPABILITIES.invoicesWrite,
      },
      {
        href: "/invoices/addinvoices",
        title: "Excel Invoices",
        capability: CAPABILITIES.invoicesWrite,
      },
    ],
  },
  {
    href: "/claims/AllExciseClaims",
    icon: Package,
    title: "Excise Claims",
    capability: CAPABILITIES.claimsWrite,
  },
  {
    href: "/claims/AllClaims",
    icon: Briefcase,
    title: "VAT Claims",
    capability: CAPABILITIES.claimsWrite,
  },
  {
    href: "/financial",
    icon: CreditCard,
    title: "Financial",
    capability: CAPABILITIES.prefinanceRead,
    children: [
      {
        href: "/financial/AllPreFinancing",
        title: "All pre-financing",
        capability: CAPABILITIES.prefinanceRead,
      },
    ],
  },
];
const SettingsSection = [
  {
    href: "/settings/adminsettings/AccountManagers",
    icon: Globe,
    title: "Global Settings",
    capability: CAPABILITIES.settingsGlobal,
    children: [
      {
        href: "/settings/adminsettings/AccountManagers",
        title: "Account Managers",
        anyOf: [
          { capability: CAPABILITIES.settingsGlobal, minLevel: "R" },
          { capability: CAPABILITIES.customersProvisionUsers, minLevel: "X" },
        ],
      },
      {
        href: "/settings/globalsettings/suppliers",
        title: "Suppliers",
        capability: CAPABILITIES.settingsGlobal,
      },
      {
        href: "/settings/globalsettings/supplierPortalInfo",
        title: "Supplier Portal Info",
        capability: CAPABILITIES.settingsGlobal,
      },
      {
        href: "/settings/globalsettings/taxoffices",
        title: "Tax Offices",
        capability: CAPABILITIES.settingsGlobal,
      },
    ],
  },
  {
    href: "/settings/globalsettings/refundrates",
    icon: Percent,
    title: "Sales Settings",
    capability: CAPABILITIES.refundRatesRead,
    children: [
      {
        href: "/settings/globalsettings/refundrates",
        title: "Refund Rates",
        capability: CAPABILITIES.refundRatesRead,
      },
    ],
  },
  {
    href: "/settings/globalsettings",
    icon: Database,
    title: "Reference Data",
    capability: CAPABILITIES.adminPanel,
    children: [
      {
        href: "/settings/globalsettings/bankaccounttypes",
        title: "Bank Account Types",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/claimstates",
        title: "Claim States",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/countries",
        title: "Countries",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/currencies",
        title: "Currencies",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/documenttypes",
        title: "Document Types",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/invoicelabels",
        title: "Invoice Labels",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/invoicestates",
        title: "Invoice States",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/paymenttypes",
        title: "Payment Types",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/producttypes",
        title: "Product Types",
        capability: CAPABILITIES.adminPanel,
      },
      {
        href: "/settings/globalsettings/relationtypes",
        title: "Relation Types",
        capability: CAPABILITIES.adminPanel,
      },
    ],
  },
];

const navItems = [
  {
    title: "Menu",
    pages: pagesSection,
  },
  {
    title: "Settings",
    pages: SettingsSection,
  },
];

export default navItems;
